'use strict';

var jwt = require('jsonwebtoken');

exports._jwt = jwt;

exports.sign = function (payload, key, opts) {
  opts = opts || {};
  return new Promise(function (resolve, reject) {
    jwt.sign(payload, key, opts, function (err, token) {
      if (err || !token) return reject(err);
      resolve(token);
    });
  });
};

exports.verify = function (token, key, opts) {
  opts = opts || {};
  return new Promise(function (resolve, reject) {
    jwt.verify(token, key, opts, function (err, verified) {
      if (err) return reject(err);
      resolve(verified);
    });
  });
};